import * as EventsConstants from '../constants';
import {pluck, reject, contains, each, find} from "underscore";

const initialState = {
  collection: [],
  isFetching: false,
  closingEvents: [],
  sorting: {
    sort: 'desc',
    order: 'created_at',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function triggerEvents(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.EVENTS_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case EventsConstants.EVENTS_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.events,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    case EventsConstants.CLOSE_STARTED:
      return Object.assign({}, state, {
        closingEvents: state.closingEvents.concat(action.events)
      });
    case EventsConstants.CLOSE_COMPLETED: {
      const closedEventIds = pluck(action.events, "id");
      const newClosingEvents = reject(state.closingEvents, (event) => contains(closedEventIds, event.patientTriggerEvent.id));

      each(action.events, (patientTriggerEvent) => {
        const event = find(state.collection, (e) => e.patientTriggerEvent.id === patientTriggerEvent.id);
        if (event)
          event.patientTriggerEvent = patientTriggerEvent;
      });

      return Object.assign({}, state, {closingEvents: newClosingEvents});
    }
    default:
      return state;
  }
}
